import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Logo = styled.img`
  width: 78px;
  height: 78px;
  border-radius: 8px;
  object-fit: contain;
`;
